<template>
	<div class="nobr feature">
		<CheckOutlined v-if="enabled" :style="{ color: green }" />
		<MinusOutlined v-else :style="{ color: red }" />
		{{ $t('tariffs.features.' + name) }}
	</div>
</template>

<script>
import { CheckOutlined, MinusOutlined } from '@ant-design/icons-vue';

import Consts from '@/api/Consts';

export default {
	components: {
		CheckOutlined, MinusOutlined,
	},
	props: ['enabled', 'name'],
	setup() {
		return {
			green: Consts.COLORS.successDark,
			red: Consts.COLORS.errorDark,
		};
	},
}
</script>

<style scoped>
.feature {
	margin-top: 4px;
}
</style>